// extracted by mini-css-extract-plugin
export default {"planCard":"styles_planCard__Ch+2K","title":"styles_title__QVANE","price":"styles_price__76gj6","selected":"styles_selected__Br3gL"};